import { Component } from '@angular/core';
import { ScreenTrackingService } from '@angular/fire/analytics';

import { ThemeService } from './shared/services/theme.service';
import { NavigationRecoveryService } from './shared/services/navigation-recovery.service';
import { FirestoreWarmupService } from './shared/services/firestore-warmup.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  constructor(
    private themeService: ThemeService,
    private navigationRecoveryService: NavigationRecoveryService,
    private firestoreWarmupService: FirestoreWarmupService,
    // Injected for its side effect: provideAnalytics() registers ScreenTrackingService
    // but never instantiates it, so without an explicit injection Angular would never
    // construct it and no screen_view events would be logged on route changes.
    private screenTrackingService: ScreenTrackingService,
  ) {
    this.firestoreWarmupService.init();
    this.navigationRecoveryService.init();
  }
}
